import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from '@blueprint/link';
import { Text } from '@blueprint/text';

const StyledSmallPrint = styled('div')((props) => {
    const {
        theme: { colors, spacing, type, fontSizes }
    } = props;

    return css`
        font-size: ${fontSizes['1']};
        line-height: ${type.lineHeight};
        color: ${colors['primary-dark']};

        ${Text} {
            font-size: ${fontSizes['1']};
            margin-top: ${spacing['spacing-4']};
            color: ${colors['primary-dark']};
        }
    `;
});

const StyledSmallPrintLayout = styled('div')((props) => {
    const {
        theme: { mq, spacing }
    } = props;
    return css`
        display: block;

        ${mq.small} {
            display: flex;
            justify-content: space-between;

            & > div {
                width: calc(50% - ${spacing['spacing-3']});
            }
        }
    `;
});

const List = styled('ul')`
    padding: 0;
`;
const ListItem = styled('li')((props) => {
    const {
        theme: { spacing }
    } = props;

    return css`
        display: inline-block;
        margin-right: ${spacing['spacing-2']};

        > * {
            margin: 0;
        }
    `;
});

const StyledLink = styled(Link)((props) => {
    const {
        theme: { colors }
    } = props;

    return css`
        color: ${colors['primary-dark']};
        text-decoration-color: transparent;
    `;
});

export { StyledSmallPrint, StyledSmallPrintLayout, List, ListItem, StyledLink };
